( function() {

console.log('hello perimeter');

var mainMenuControl = document.querySelector('.main-menu-control');
if (mainMenuControl) {
	mainMenuControl.addEventListener( 'click', () => {
		const mainMenu = document.querySelector('.main-nav-modal');
		const docBody = document.body;
		const mainMenuClose = document.querySelector('.main-menu-close');
		const nonModals = document.querySelectorAll('.global--non-modal');

		mainMenu.classList.remove('main-nav-modal--hidden');
		mainMenu.classList.add('main-nav-modal--open');
		docBody.classList.toggle('body--overlay-open');

		if (nonModals) {
			nonModals.forEach(nonModal => {
				nonModal.setAttribute('inert', true);
			});
		};
		mainMenuClose.focus();

	} );
}

var mainMenuClose = document.querySelector('.main-menu-close');
if (mainMenuClose) {
	mainMenuClose.addEventListener( 'click', () => {
		const mainMenu = document.querySelector('.main-nav-modal');
		const docBody = document.body;
		var mainMenuControl = document.querySelector('.main-menu-control');
		const nonModals = document.querySelectorAll('.global--non-modal');

		mainMenu.classList.remove('main-nav-modal--open');
		mainMenu.classList.add('main-nav-modal--hidden');
		docBody.classList.toggle('body--overlay-open');

		if (nonModals) {
			nonModals.forEach(nonModal => {
				nonModal.removeAttribute('inert');
			});
		};

		mainMenuControl.focus();

	} );
}

//menu img hover
const menuImgs = document.querySelectorAll('.perimeter-main-menu-img');
const menuLinks = document.querySelectorAll('.perimeter-main-menu-link');

if (menuImgs && menuLinks) {
	console.log('menu and linke')
	menuLinks.forEach( ( link ) => { 	
		link.addEventListener( 'mouseover', () => {
			const getTarget = link.dataset.mainMenuLink;
			const windowWidth = window.innerWidth;
			menuImgs.forEach( ( img ) => { 
				if ((img.dataset.imageTag == getTarget) && (windowWidth > 779)) {
					console.log(windowWidth);
					img.classList.add('active');
				};
			});

		});
		link.addEventListener( 'mouseout', () => {
			console.log(link);
			const getTarget = link.dataset.mainMenuLink;
			const windowWidth = window.innerWidth;
			menuImgs.forEach( ( img ) => { 
				if ((img.dataset.imageTag == getTarget) && (windowWidth > 779)) {
					img.classList.remove('active');
				};
			});
		});	
	});
};


//scrolling animation
var videoBlock = document.querySelectorAll('.perimeter-video-header');
if (videoBlock) {
	videoBlock.forEach( ( block ) => { 		
		const video = document.querySelector( '.perimeter-video-header' );
		const sentinel = document.querySelector( '.sentinel' );
		const videoObserver = new IntersectionObserver( ( entries ) => {
			if ( entries[ 0 ].isIntersecting ) {
			
				// console.log(sideBump);
				const sideBump = -20;
				const videoTween = new TimelineMax()
					.to(".left-bumper", 1, {left: -40, delay: 0})
					.to(".right-bumper", 1, {right: -40, delay: 0}, "<")
					.to(".top-bumper", 1.5, {top: -130, delay: 0}, "<");
				videoTween.play();

			} else {
				const screenWidth = window.innerWidth;

				if (screenWidth > 779) {
				const videoTween = new TimelineMax()
					.to(".left-bumper", 1, {left: 0, delay: 0})
					.to(".right-bumper", 1, {right: 0, delay: 0}, "<")
					.to(".top-bumper", 1.5, {top: 0, delay: 0}, "<");
				videoTween.play();
				} else {
					const videoTween = new TimelineMax()
					.to(".left-bumper", 1, {left: -20, delay: 0})
					.to(".right-bumper", 1, {right: -20, delay: 0}, "<")
					.to(".top-bumper", 1.5, {top: -20, delay: 0}, "<");
				videoTween.play();
				};
				
				
			}
		} );

		videoObserver.observe( sentinel );

	});

};

var videoBlockReverse = document.querySelectorAll('.perimeter-video-header-reverse');
if (videoBlockReverse) {
	videoBlockReverse.forEach( ( block ) => { 		
		const video = block.querySelector( '.perimeter-video-header-reverse' );
		const pauseButton = block.querySelector( '.js-pause-bg-video' );
		const sentinel = block.querySelector( '.sentinel' );
		const videoObserver = new IntersectionObserver( ( entries ) => {
			if ( entries[ 0 ].isIntersecting ) {
				const screenWidth = window.innerWidth;
				if (screenWidth > 779) {
					const videoTween = new TimelineMax()
						.to(pauseButton, 0.8, {right: 50, delay: 0})
						.to(".left-bumper", 1, {left: 0, delay: 0},"<")
						.to(".right-bumper", 1, {right: 0, delay: 0}, "<")
						.to(".top-bumper", 1.5, {top: 0, delay: 0}, "<");
					videoTween.play();
				} else {
					const videoTween = new TimelineMax()
						.to(pauseButton, 0.8, {right: 30, delay: 0})
						.to(".left-bumper", 1, {left: -20, delay: 0}, "<")
						.to(".right-bumper", 1, {right: -20, delay: 0}, "<")
						.to(".top-bumper", 1.5, {top: -20, delay: 0}, "<");
					videoTween.play();
				};
				

			} else {
				const screenWidth = window.innerWidth;

				if (screenWidth > 779) {
					const videoTween = new TimelineMax()
						.to(pauseButton, 0.8, {right: 10, delay: 0})
						.to(".left-bumper", 1, {left: -40, delay: 0}, "<")
						.to(".right-bumper", 1, {right: -40, delay: 0}, "<")
						.to(".top-bumper", 1.5, {top: -130, delay: 0}, "<");
					videoTween.play();
				} else {
					const videoTween = new TimelineMax()
						.to(pauseButton, 0.8, {right: 10, delay: 0})
						.to(".left-bumper", 1, {left: -40, delay: 0},"<")
						.to(".right-bumper", 1, {right: -40, delay: 0}, "<")
						.to(".top-bumper", 1.5, {top: -130, delay: 0}, "<");
					videoTween.play();
				};
				
				
			}
		} );

		videoObserver.observe( sentinel );

	});

};
//end scrolling animation

const videoWithPause = document.querySelectorAll('.perimeter-video-with-pause');
if (videoWithPause) {
	videoWithPause.forEach( ( block ) => { 
		
		const pauseButton = block.querySelector( '.js-pause-bg-video' );
		const pauseButtonText = block.querySelector( '.js-pause-button-text' );
		const allPauseButton = document.querySelectorAll( '.js-pause-bg-video' );
		const allPauseButtonText = document.querySelectorAll( '.js-pause-button-text' );

		const videos = document.querySelectorAll( '.perimeter-video-with-pause video' );
		pauseButton.addEventListener( 'click', () => { 
			const videoState = pauseButton.dataset.videoState;
			if (videoState == 'playing') {
				console.log('video playing');
				pauseButton.dataset.videoState = "paused";
				pauseButtonText.innerHTML = "Play";
				if (videos) {
					videos.forEach( ( video ) => { 
						video.pause();
					});
				};
				if (allPauseButton) {
					allPauseButton.forEach( ( button ) => { 
						button.dataset.videoState = "paused";
					});
				};
				if (allPauseButtonText) {
					allPauseButtonText.forEach( ( text ) => { 
						text.innerHTML = "Play";
					});
				};
				if (allPauseButton) {
					allPauseButton.forEach( ( button ) => { 
						button.classList.remove('perimeter-pause-button--playing');
						button.classList.add('perimeter-pause-button--paused');
					});
				};

			} else {
				console.log('video pause');
				pauseButton.dataset.videoState = "playing";
				pauseButtonText.innerHTML = "Pause";
				if (videos) {
					videos.forEach( ( video ) => { 
						video.play();
					});
				};
				if (allPauseButton) {
					allPauseButton.forEach( ( button ) => { 
						button.dataset.videoState = "playing";
					});
				};
				if (allPauseButtonText) {
					allPauseButtonText.forEach( ( text ) => { 
						text.innerHTML = "Pause";
					});
				};
				if (allPauseButton) {
					allPauseButton.forEach( ( button ) => { 
						button.classList.add('perimeter-pause-button--playing');
						button.classList.remove('perimeter-pause-button--paused');
					});
				};
			};
		});

	});
};


//team overlay
const cardOverlayBlock = document.querySelectorAll( '.ar-card-overlay-block' );
if (cardOverlayBlock) {
	cardOverlayBlock.forEach( ( block ) => { 
		const overlayControl = block.querySelectorAll( '.ar-card-overlay-trigger' );
		if (overlayControl) {
			overlayControl.forEach( ( button ) => {

				button.addEventListener( 'click', () => {
					const number = button.getAttribute('id').split('-').pop();
					const associatedPopup = block.querySelector(`#ar-card-overlay-${number}`);
					const modal = associatedPopup.querySelector('.bio-modal-content');
					const docBody = document.body;
					const nonModals = document.querySelectorAll('.global--non-modal');
					// console.log('cliched button' + number + associatedPopup);

					if (nonModals) {
						nonModals.forEach(nonModal => {
							nonModal.setAttribute('inert', true);
						});
					};
					
					associatedPopup.removeAttribute('inert');
					associatedPopup.classList.remove('closed');
					associatedPopup.classList.add('open');
					modal.classList.add('slide-up');
					docBody.classList.add('body--overlay-open');
				});

			} );	
		};

	});
};

//close team overlay
const closeOverlay = document.querySelectorAll( '.js-close-overlay' );
if (closeOverlay) {
	closeOverlay.forEach( ( closeButton ) => {
		closeButton.addEventListener( 'click', () => {
			console.log('clicked close button');
			const docBody = document.body;
			const overlays = document.querySelectorAll('.hbc-overlay');
			const nonModals = document.querySelectorAll('.global--non-modal');
			const activeModal = closeButton.closest('.perimeter-team-bio-modal');
			const activeModalId = activeModal.getAttribute('id').split('-').pop();
			const associatedButton = document.querySelector(`#ar-card-overlay-trigger-${activeModalId}`);

			// console.log(activeModal);

			if (nonModals) {
				nonModals.forEach(nonModal => {
					nonModal.removeAttribute('inert');
				});
			};

			if (docBody.classList.contains('body--overlay-open')) {
				docBody.classList.remove('body--overlay-open')
			};
			
			overlays.forEach( (overlay) => {
				const opened = overlay.querySelector('.bio-modal-content');
				if (opened.classList.contains('slide-up')) {
					opened.classList.remove('slide-up');
					opened.closest('.perimeter-team-bio-modal').setAttribute('inert', true);
				};
				if (overlay.classList.contains('open')) {
					overlay.classList.remove('open');
					overlay.classList.add('closed');
				};
			});
			
			associatedButton.focus();
		});
	} );	
};

//init project swiper
const projectSwiper = document.querySelectorAll('.project-swiper');
if (projectSwiper) {
	projectSwiper.forEach( ( perimeterSwiper ) => {
		const buttonNext = perimeterSwiper.querySelector('.swiper-button-next');
		const buttonPrev = perimeterSwiper.querySelector('.swiper-button-prev');
		
		// const nextSlide = perimeterSwiper.querySelector('.swiper-slide-next');

		const swiper = new Swiper(perimeterSwiper, {
		  	centeredSlides: true,
		  	slidesPerView: 'auto',
		  	loop: true,
		  	effect: 'slide',

			navigation: {
		    	nextEl: buttonNext,
		    	prevEl: buttonPrev,
		  	},

		  	on: {
		      	init: function () {
		        	const getActiveSlide = perimeterSwiper.querySelector('.swiper-slide-active');
					const slideInfo = getActiveSlide.dataset.perimeterTitle;
					const slideLink = getActiveSlide.dataset.perimeterLink;
					const titleTarget = perimeterSwiper.querySelector('.img-slide-info p');
					const linkTarget = perimeterSwiper.querySelector('.img-slide-info a');
  					titleTarget.innerHTML = getActiveSlide.dataset.perimeterTitle;
  					if (linkTarget) {
  						linkTarget.setAttribute('href', slideLink);
  					};
		      	},
		    }
		});
		
		swiper.on('slideChangeTransitionEnd', function () {
			const getActiveSlide = perimeterSwiper.querySelector('.swiper-slide-active');
			const getNextActiveSlide = getActiveSlide.nextSibling;
			const slideInfo = getActiveSlide.dataset.perimeterTitle;
			const slideLink = getActiveSlide.dataset.perimeterLink;
			const titleTarget = perimeterSwiper.querySelector('.img-slide-info p');
			const linkTarget = perimeterSwiper.querySelector('.img-slide-info a');
  			console.log('slide changed');
  			console.log(getActiveSlide);
  			console.log(slideInfo);
  			titleTarget.innerHTML = getActiveSlide.dataset.perimeterTitle;
  			if (linkTarget) {
  				linkTarget.setAttribute('href', slideLink);
  			};
		});


		perimeterSwiper.addEventListener( 'click', function ( event ) {
		    const nextSlide = event.target.closest('.swiper-slide-next');
		    const prevSlide = event.target.closest('.swiper-slide-prev');
		    if (nextSlide) {
		    	console.log('clicked next slide'); 	
		    	swiper.slideNext(500);
		    };
		    if (prevSlide) {
		    	console.log('clicked prev slide'); 	
		    	swiper.slidePrev(500);
		    };
		} );

		

	} );
};

//scrolling image burst animation
var imageBurstBlock = document.querySelectorAll('.perimeter-text-with-image-animation');
if (imageBurstBlock) {
	imageBurstBlock.forEach( ( block ) => { 		
		const video = document.querySelector( '.img-wrapper-inner' );
		const sentinel = block.querySelector( '.sentinel' );
		const burstObserver = new IntersectionObserver( ( entries ) => {
			if ( entries[ 0 ].isIntersecting ) {
				
				// video.classList.add( 'cover' );
				video.classList.remove( 'cover' );
			} else {
				
				// video.classList.remove( 'cover' );
			}
		} );

		burstObserver.observe( sentinel );

	});

};
//end scrolling animation

//gallery modals
const modalGallery = document.querySelectorAll('.perimeter-gallery-with-modal');

if (modalGallery) {
	modalGallery.forEach( ( gallery ) => { 

		const galleryModalControl = gallery.querySelectorAll( '.light-box-trigger' );
		if (galleryModalControl) {
			galleryModalControl.forEach( ( button ) => {

				button.addEventListener( 'click', () => {
					const number = button.getAttribute('id').split('-').pop();
					const associatedPopup = gallery.querySelector(`#perimeter-gallery-modal-${number}`);
					const findClose = associatedPopup.querySelector('.js-close-gallery-modal');
					const docBody = document.body;
					const nonModals = document.querySelectorAll('.global--non-modal');
					const imgArea =  associatedPopup.querySelector('.gallery-modal-img-wrapper');
					const imgAreaWidth = window.innerWidth - 40;
					const imgAreaHeight = window.innerHeight - 110;
					const imgAreaAspect = imgAreaWidth/imgAreaHeight;

					const getImg = button.querySelector('img');	
					const modalImg = associatedPopup.querySelector('img');	
					const imgWidth = getImg.width;
					const imgHeight = getImg.height;
					const imgAspect = imgWidth/imgHeight;

					// console.log(imgAreaWidth);
					// console.log(imgAreaHeight);
					// console.log(imgAreaAspect);

					// console.log(imgWidth);
					// console.log(imgHeight);
					// console.log(imgAspect);

					if (imgAreaAspect > imgAspect) {
						console.log('area aspect greater than image aspect')
						modalImg.classList.add('height-100');
					} else if (imgAreaAspect < imgAspect) {
						console.log('area aspect less than image aspect')
						modalImg.classList.add('width-100');
					} else if (imgAreaAspect = imgAspect) {
						console.log('area aspect equal to image aspect')
						modalImg.classList.add('width-100');
					};

					if (nonModals) {
						nonModals.forEach(nonModal => {
							nonModal.setAttribute('inert', true);
						});
					};
					
					associatedPopup.removeAttribute('inert');
					associatedPopup.classList.remove('closed');
					associatedPopup.classList.add('open');
					findClose.focus();
					docBody.classList.add('body--overlay-open');
				});

			} );	
		};

	});
};

//close gallery modals
const closeGalleryOverlay = document.querySelectorAll( '.js-close-gallery-modal' );
if (closeGalleryOverlay) {
	closeGalleryOverlay.forEach( ( closeButton ) => {
		closeButton.addEventListener( 'click', () => {
			console.log('clicked close button');
			const docBody = document.body;
			const overlays = document.querySelectorAll('.perimeter-gallery-modal');
			const nonModals = document.querySelectorAll('.global--non-modal');
			const activeModal = closeButton.closest('.perimeter-gallery-modal');
			const activeModalId = activeModal.getAttribute('id').split('-').pop();
			const wrapper = closeButton.closest('.perimeter-image-gallery');
			const associatedButton = wrapper.querySelector(`#light-box-trigger-${activeModalId}`);

			// console.log(activeModal);

			if (nonModals) {
				nonModals.forEach(nonModal => {
					nonModal.removeAttribute('inert');
				});
			};

			if (docBody.classList.contains('body--overlay-open')) {
				docBody.classList.remove('body--overlay-open')
			};
			
			overlays.forEach( (overlay) => {
			
				if (overlay.classList.contains('open')) {
					overlay.classList.remove('open');
					overlay.classList.add('closed');
					closeButton.closest('.perimeter-gallery-modal').setAttribute('inert', true);
				};
				// if (overlay.classList.contains('open')) {
				// 	overlay.classList.remove('open');
				// 	overlay.classList.add('closed');
				// };
			});
			
			associatedButton.focus();
		});
	} );	
};

} )();